// extracted by mini-css-extract-plugin
export default {"root":"_1bPRk","heading-and-subheading-block":"_3mNyW","headingAndSubheadingBlock":"_3mNyW","subheading":"_3Z5PA"};